import { ActionIcon, SegmentedControl, Tooltip } from '@mantine/core';
import { IconClick, IconEye, IconFocus2, IconPlayerRecordFilled, IconPlayerPauseFilled } from '@tabler/icons-react';
import { useAtom, useAtomValue } from 'jotai';
import { recorderClickModeAtom, recorderPausedAtom, recordTypeAtom } from '~/atoms/recorder-atoms';
import { useBreakpoint } from '~/hooks/vm/useBreakpoint';
import { useSendVmCommand } from '~/hooks/vm/useSendVmCommand';
import IconSingleClick from '../icons/IconSingleClick';
import { RecorderClickModeExplanation, TOUR_ID } from '../tours/DraftEditorTour';
import clsx from 'clsx';

export default function ToolbarActions({ isWeb }: { aiActionButton?: () => void; isWeb: boolean }) {
  const [recordType, setRecordType] = useAtom(recordTypeAtom);
  const recorderPaused = useAtomValue(recorderPausedAtom);
  const [recorderClickMode, setRecorderClickMode] = useAtom(recorderClickModeAtom);

  const sendVmCommand = useSendVmCommand();
  const size = useBreakpoint(1400) ? 'xs' : 'sm';

  return (
    <>
      {!!isWeb && (
        <>
          <ActionIcon
            id={TOUR_ID.FLOATING_TOOLBAR_RECORD}
            title={recorderPaused ? 'Resume recording' : 'Pause recording'}
            variant="transparent"
            className="flex items-center space-x-1"
            onClick={() => {
              sendVmCommand({ type: 'toggle-pause' });
            }}
          >
            {recorderPaused ?
              <IconPlayerRecordFilled
                className="text-red-600"
                size={20}
              />
            : <IconPlayerPauseFilled
                className="text-gray-600 dark:text-gray-400"
                size={20}
              />
            }
          </ActionIcon>

          <SegmentedControl
            id={TOUR_ID.FLOATING_TOOLBAR_RECORD_TYPE}
            className="pointer-events-auto"
            value={recordType}
            onChange={setRecordType}
            size={size}
            data={[
              {
                label: (
                  <div className="flex items-center space-x-1">
                    <IconClick size={12} />
                    <div className="text-xs">Act</div>
                  </div>
                ),
                value: 'action',
              },
              {
                label: (
                  <div className="flex items-center space-x-1">
                    <IconEye size={12} />
                    <div className="text-xs">Assert</div>
                  </div>
                ),
                value: 'assertion',
              },
            ]}
          />
          <Tooltip
            multiline
            label={<RecorderClickModeExplanation />}
            maw={260}
            withArrow
            openDelay={500}
          >
            <ActionIcon
              id={TOUR_ID.FLOATING_TOOLBAR_RECORDER_CLICK_MODE_ACTION}
              variant={recorderClickMode === 'center' ? 'default' : 'filled'}
              color={recorderClickMode === 'center' ? undefined : 'blue'}
              className={clsx('mx-1 mr-2 border-0', { 'bg-transparent': recorderClickMode === 'center' })}
              size={24}
              onClick={() => setRecorderClickMode(recorderClickMode === 'center' ? 'relative' : 'center')}
            >
              {recorderClickMode === 'center' ?
                <IconFocus2 size={18} />
              : <IconSingleClick className="w-5" />}
            </ActionIcon>
          </Tooltip>
        </>
      )}
    </>
  );
}
